export function base64ToBlob(base64: string, mimeType: string) {
  const byteString = atob(base64)
  const ab = new ArrayBuffer(byteString.length)
  const ia = new Uint8Array(ab)

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }

  return new Blob([ab], {type: mimeType})
}

export function blobToFile(blob: Blob, fileName: string) {
  return new File([blob], fileName, {type: blob.type})
}
